import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { PublishOpportunityModalProps } from './PublishOpportunityModal.types'

export function PublishOpportunityModal({
  open,
  handleClose,
  handlePublishOpportunity,
  isLoading,
  opportunityName
}: Readonly<PublishOpportunityModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="publish-opportunity-modal">
      <ActionModal
        title={t('typography.volunteering.publishOpportunity.title')}
        primaryButtonText={t('typography.yesPublish')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={handlePublishOpportunity}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.volunteering.publishOpportunity.description"
          components={{ b: <b /> }}
          values={{ opportunityName }}
        />
      </ActionModal>
    </Modal>
  )
}
